// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notes-list .ant-list-header {
  padding: 5px 16px !important;
}
.notes-list .ant-list-pagination {
  margin: 10px 24px !important;
}
.notes-list em {
  font-style: italic !important;
}
.notes-list .iframe-subject {
  width: 100%;
}
.notes-list .note-subject-compact {
  width: 600px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.note-row {
  width: 100%;
}
.note-row .note-owner {
  font-size: 12px;
  font-weight: 700;
}
.note-row .note-timestamp {
  margin-left: 10px;
}
.note-row .note-reminder,
.note-row .note-timestamp {
  color: #8c8d8e;
}
.note-row .note-reminder,
.note-row .note-type {
  margin-left: 20px;
}
.note-row .note-type,
.note-row .note-timestamp,
.note-row .note-reminder {
  font-size: 10px;
}
.note-row .note-reminder-popover {
  width: 10px;
  height: 10px;
  margin-left: 5px;
  cursor: pointer;
}
.note-row .note-reminder-popover-email {
  display: right;
}
.note-row .note-attachment {
  font-size: 12px;
  margin-left: 5px;
}
.note-row .note-subject {
  margin-bottom: 8px;
  width: 100%;
}
.comment-message {
  margin-top: 1px;
  margin-bottom: 5px;
  width: 100%;
}
.comment-form-list-item {
  justify-content: center !important;
}
.note-header-title,
.note-header-actions {
  display: flex !important;
  align-items: center;
}
.note-header-actions {
  justify-content: flex-end;
}
.note-header-actions .header-filter-form {
  display: flex !important;
  justify-content: space-between;
}
.note-header-actions .ant-checkbox-wrapper {
  margin-right: 20px;
}
.note-header-actions button {
  margin-right: 7px;
}
.note-header-actions button:last-child {
  margin-right: 0;
}
.note-new-type-action-btn {
  display: inline-block !important;
  margin: 0 0 0 12px !important;
}
.subject-form-item-errored label {
  color: red !important;
}
.subject-form-item-errored div[role='application'] {
  border-color: red;
}
.nc-notes-checkbox div {
  all: unset;
}
.ant-form-item {
  margin-bottom: 13px !important;
}
.comments-list .ant-list-pagination {
  margin: 3px 20px !important;
}
.comments-list .ant-list-item {
  align-items: unset;
  padding: 6px 16px 4px 16px !important;
}
.file-manager-container {
  height: 650px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/notes/styles.less"],"names":[],"mappings":"AAAA;EAEI,4BAAA;AAAJ;AAFA;EAMI,4BAAA;AADJ;AALA;EAUI,6BAAA;AAFJ;AARA;EAcI,WAAA;AAHJ;AAXA;EAkBI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;AAQA;EACE,WAAA;AANF;AAKA;EAII,eAAA;EACA,gBAAA;AANJ;AACA;EASI,iBAAA;AAPJ;AAFA;;EAcI,cAAA;AARJ;AANA;;EAmBI,iBAAA;AATJ;AAVA;;;EAyBI,eAAA;AAVJ;AAfA;EA8BI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAZJ;AArBA;EAqCI,cAAA;AAbJ;AAxBA;EAyCI,eAAA;EACA,gBAAA;AAdJ;AA5BA;EA8CI,kBAAA;EACA,WAAA;AAfJ;AAmBA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;AAjBF;AAoBA;EACE,kCAAA;AAlBF;AAqBA;;EAEE,wBAAA;EACA,mBAAA;AAnBF;AAsBA;EACE,yBAAA;AApBF;AAmBA;EAII,wBAAA;EACA,8BAAA;AApBJ;AAeA;EASI,kBAAA;AArBJ;AAYA;EAaI,iBAAA;AAtBJ;AASA;EAiBI,eAAA;AAvBJ;AA2BA;EACE,gCAAA;EACA,6BAAA;AAzBF;AA4BA;EAEI,qBAAA;AA3BJ;AAyBA;EAMI,iBAAA;AA5BJ;AAgCA;EAEI,UAAA;AA/BJ;AAmCA;EACE,8BAAA;AAjCF;AAoCA;EAEI,2BAAA;AAnCJ;AAiCA;EAMI,kBAAA;EACA,qCAAA;AApCJ;AAwCA;EACE,wBAAA;AAtCF","sourcesContent":[".notes-list {\n  .ant-list-header {\n    padding: 5px 16px !important;\n  }\n\n  .ant-list-pagination {\n    margin: 10px 24px !important;\n  }\n\n  em {\n    font-style: italic !important;\n  }\n\n  .iframe-subject {\n    width: 100%;\n  }\n\n  .note-subject-compact {\n    width: 600px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.note-row {\n  width: 100%;\n\n  .note-owner {\n    font-size: 12px;\n    font-weight: 700;\n  }\n\n  .note-timestamp {\n    margin-left: 10px;\n  }\n\n  .note-reminder,\n  .note-timestamp {\n    color: #8c8d8e;\n  }\n\n  .note-reminder,\n  .note-type {\n    margin-left: 20px;\n  }\n\n  .note-type,\n  .note-timestamp,\n  .note-reminder {\n    font-size: 10px;\n  }\n\n  .note-reminder-popover\n  {\n    width: 10px;\n    height: 10px;\n    margin-left: 5px;\n    cursor: pointer;\n  }\n  .note-reminder-popover-email\n  {\n    display: right;\n  }\n\n  .note-attachment {\n    font-size: 12px;\n    margin-left: 5px;\n  }\n\n  .note-subject {\n    margin-bottom: 8px;\n    width: 100%;\n  }\n}\n\n.comment-message {\n  margin-top: 1px;\n  margin-bottom: 5px;\n  width: 100%;\n}\n\n.comment-form-list-item {\n  justify-content: center !important;\n}\n\n.note-header-title,\n.note-header-actions {\n  display: flex !important;\n  align-items: center;\n}\n\n.note-header-actions {\n  justify-content: flex-end;\n\n  .header-filter-form {\n    display: flex !important;\n    justify-content: space-between;\n  }\n\n  .ant-checkbox-wrapper {\n    margin-right: 20px;\n  }\n\n  button {\n    margin-right: 7px;\n  }\n\n  button:last-child {\n    margin-right: 0;\n  }\n}\n\n.note-new-type-action-btn {\n  display: inline-block !important;\n  margin: 0 0 0 12px !important;\n}\n\n.subject-form-item-errored {\n  label {\n    color: red !important;\n  }\n\n  div[role='application'] {\n    border-color: red;\n  }\n}\n\n.nc-notes-checkbox {\n  div {\n    all: unset;\n  }\n}\n\n.ant-form-item {\n  margin-bottom: 13px !important;\n}\n\n.comments-list {\n  .ant-list-pagination {\n    margin: 3px 20px !important;\n  }\n\n  .ant-list-item {\n    align-items: unset;\n    padding: 6px 16px 4px 16px !important;\n  }\n}\n\n.file-manager-container {\n  height: 650px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
